/**
 * Example JavaScript singleton module
 */

var Expandables = (function($) {

  function initExpandables() {
    // do something
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.post-content-expandable__block').length) {
      return;
    }

    var expandableBlock = $('.post-content-expandable__block');

    expandableBlock.click(function(){
        $(this).find('.circle-plus').toggleClass('closed');
        $(this).find('.circle-plus').toggleClass('opened');
        $(this).find('.post-content-expandable__wrapper').toggleClass('post-content-expandable__wrapper--collapsed');
    });

    initExpandables();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Expandables.init);
